import { Box, Grid, Typography, styled, Stack } from "@mui/material"
import { motion } from "motion/react"
import ReservationComp from "../ReservationComp/ReservationComp";




const TitleText = styled(Typography)(({ theme }) => ({
    textTransform: "uppercase",
    color: theme.palette.secondary.main,
    fontWeight: 500
}));


const BoxGrid = styled(Grid)(({ theme }) => ({
    backgroundColor: "rgb(245,245,245)",
    width: "100%",
    alignContent: "center",
    textAlign: "left",
    padding: theme.spacing(3)
}));

function LocationsBlog({children}) {
    return (
        <>
            <Box sx={{
                width: "100%",
                minHeight: "80vh",
                alignContent: "center",
                alignItems: "center",
            }}>
                <Grid container spacing={2} display={"flex"} justifyContent={"space-between"}>
                    <Grid item xs={12} md={7} component={motion.div} initial={{ opacity: 0, transform: "translateX(100px)" }} viewport={{ once: true }} whileInView={{ opacity: 1, transform: "translateX(0px)", transition: { delay: 0.5 } }}>
                        {children}

                        <ReservationComp></ReservationComp>
                    </Grid>
                    <BoxGrid item md={4}>
                        <Grid container gap={2}>
                            <Grid item xs={12} md={12}>
                                <Typography variant="h4" textAlign={"center"} color={"primary"}>Ceník</Typography>
                            </Grid>
                            <BoxGrid item xs={12} sx={{
                                textAlign: "center",
                            }}>
                                <Stack>
                                    <TitleText variant="body1" >Vozidlo s řidičem</TitleText>
                                    <Typography variant="body1" fontWeight={600}>1000 Kč/h</Typography>
                                </Stack>
                            </BoxGrid>
                            <BoxGrid item xs={12} sx={{
                                textAlign: "center"
                            }}>
                                <Stack>
                                    <TitleText variant="body1" >+1. stěhovák</TitleText>
                                    <Typography variant="body1" fontWeight={600}>250 Kč/h</Typography>
                                </Stack>
                            </BoxGrid>
                            <BoxGrid item xs={12} sx={{
                                textAlign: "center"
                            }}>
                                <Stack>
                                    <TitleText variant="body1" >+2. stěhovák</TitleText>
                                    <Typography variant="body1" fontWeight={600}>500 Kč/h</Typography>
                                </Stack>
                            </BoxGrid>
                        </Grid>
                        <Typography variant="subtitle2" sx={{
                            mt: 1
                        }}>
                            *Cena je včetně DPH a je platná pouze pro stěhování v rámci Mladé Boleslavi.
                        </Typography>
                    </BoxGrid>
                </Grid>
            </Box>
        </>
    )
}

export default LocationsBlog